

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class LocalePicker extends Vue {
  public get locales() {
    return Object.keys(this.$i18n.messages);
  }
  public get locale() {
    return this.$i18n.locale;
  }
  public set locale(value: string) {
    this.$i18n.locale = value;
    window.localStorage.locale = value;
  }
}
